import { useApiMutation } from '@/modules/common';

import { CreateModelSizeBody, ModelSizeDetails } from '../types';

export function useCreateModelSize() {
  const createModelSizeMutation = useApiMutation<
    CreateModelSizeBody,
    ModelSizeDetails
  >('/models/sizes', {
    method: 'POST',
  });

  return {
    createModelSizeMutation,
  } as const;
}
